/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_VelocityInputs */

const en_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead Velocity`)
};

const es_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de leads`)
};

const fr_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse d'acquisition`)
};

const de_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead-Geschwindigkeit`)
};

const ja_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リード獲得速度`)
};

const zh_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线索增长速度`)
};

const ar_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سرعة جلب العملاء المحتملين`)
};

const id_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecepatan Prospek`)
};

const it_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità di Acquisizione Lead`)
};

const ru_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Динамика лидов`)
};

const pt_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade de Leads`)
};

const ko_lead_velocity = /** @type {(inputs: Lead_VelocityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리드 생성 속도`)
};

/**
* | output |
* | --- |
* | "Lead Velocity" |
*
* @param {Lead_VelocityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const lead_velocity = /** @type {((inputs?: Lead_VelocityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_VelocityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_velocity(inputs)
	if (locale === "es") return es_lead_velocity(inputs)
	if (locale === "fr") return fr_lead_velocity(inputs)
	if (locale === "de") return de_lead_velocity(inputs)
	if (locale === "ja") return ja_lead_velocity(inputs)
	if (locale === "zh") return zh_lead_velocity(inputs)
	if (locale === "ar") return ar_lead_velocity(inputs)
	if (locale === "id") return id_lead_velocity(inputs)
	if (locale === "it") return it_lead_velocity(inputs)
	if (locale === "ru") return ru_lead_velocity(inputs)
	if (locale === "pt") return pt_lead_velocity(inputs)
	return ko_lead_velocity(inputs)
});